define('bizzabo/views/main/MainView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/DynamicallyGeneratedView'
], function(
    $,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    Consts,
    DynamicallyGeneratedView
    ) {

    var MainView = DynamicallyGeneratedView.extend({

        /**
         * the css class of the tab that causes this main page to appear
         */
        tabClass : '',
        contentView : undefined,
        rightPanelView : undefined,
        letMeRemoveIntro : false,

        events : {
            "click a.button-close-details" : "toggleDetails"
        },

        initialize: function() {
            this.listenTo(Backbone, 'details-open', this.openDetails);
            this.listenTo(Backbone, 'details-back-to-top', this.scrollToTop);
        },

        scrollToTop: function(selector) {
            var detailsContent = this.$('.details-content');
            var element = this.$(selector);
            detailsContent.animate({
                scrollTop: (element.offset().top + detailsContent.scrollTop() - detailsContent.offset().top)
            }, 700);
        },

        // Rendering

        renderMainView : function(options) {
            options = options || {};
            var cls = options.isAgenda ? 'main-content transition main-content-agenda-specific' : 'main-content transition';
            var html = '<section class="' + cls + '"></section>';
            if (options) {
                if (options.hasDetails) {
                    html += '<aside class="details transition"><p><a class="arrowButton button-close-details">X</a></p><section class="details-content transition"></section></aside>';
                }
                if (options.wantsFullWidth) {
                    this.$el.addClass('wants-full-width');
                }
                if (options.detailsSizeClass) {
                    this.$el.addClass(options.detailsSizeClass);
                }
                if (options.startWithHiddenDetails) {
                    this.$el.addClass("startWithHiddenDetails");
                }
            }
            this.$el.html(html);
        },

        removeMainView : function() {
            this.removeContentView();
            this.removeRightPanelView();
            this.off();
            this.undelegateEvents();
            this.stopListening();
            this.$el.remove();
        },

        // Right Panel (Detail view)

        isDetailsOpen : function() {
            return this.$el.hasClass('details-normal');
        },

        toggleDetails : function(action) {
            this.$el.removeClass("startWithHiddenDetails");
            this.$el.toggleClass('details-normal');

            if (_.isUndefined(action) || _.isObject(action)) {
                action = (this.$el.hasClass('details-normal') ? "Open" : "Close") + " right panel clicked";
            }

            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : action
            });
        },

        openDetails : function(noAnalysisReport) {
            this.$el.removeClass("startWithHiddenDetails");
            this.showDetails();
            if (this.isDetailsOpen()) {
                return;
            }

            this.$el.addClass('details-normal');

            noAnalysisReport || Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : "Open right panel clicked"
            });
        },

        closeDetails : function(action) {
            if (!this.isDetailsOpen()) {
                return;
            }

            if (_.isUndefined(action) || _.isObject(action)) {
                action = "Close right panel clicked";
            }

            this.$el.removeClass('details-normal');

            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : action
            });
        },

        hideDetails : function() {
            this.$(".details").hide();
        },

        showDetails : function() {
            this.$(".details").show();
        },

        removeRightPanelView : function() {
            if (this.rightPanelView) {
                this.rightPanelView.remove();
                this.rightPanelView = undefined;
            }
        },

        putRightPanelView : function(rightPanelView) {
            this.removeRightPanelView();
            this.rightPanelView = rightPanelView;
            this.rightPanelView.render();
            this.$("aside.details .details-content").html(this.rightPanelView.$el);
            this.rightPanelView.delegateEvents();
            Backbone.trigger(Consts.Notifications.rightPanel.SWITCHED);
        },

        // Content View

        removeContentView : function() {
            if (this.contentView) {
                this.contentView.remove();
                this.contentView = undefined;
            }
        },

        putContentView : function(contentView) {
            this.removeContentView();
            this.contentView = contentView;
            this.contentView.render();
            this.$(".main-content").html(this.contentView.$el);
        },

        // Fetch models helper

        prepareModels : function(models, waterfall) {
            var thisView = this;
            var success = _.after(models.length, this.loadingSuccess);
            var failure = _.once(function(errorCode, message, status) {
                if ((errorCode == BZAPI.errorCodes.NotOrganizer) ||
                    (errorCode == BZAPI.errorCodes.EntityDoesNotExist)) {
                    Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, '/', {
                        trigger : true
                    });
                } else {
                    thisView.loadingFailure();
                }
            });

            var processQueue = models.concat();
            var processNext = function() {
                if (processQueue.length === 0) {
                    return;
                }

                var next = function() {
                    processNext();
                    success();
                };

                var model = processQueue.shift();
                if (model.forceFirstFetch || (model.shouldFetch && (_.isFunction(model.isNew) ? !model.isNew() : true))) {
                    model.fetch({
                        success : next,
                        error : failure
                    });
                } else {
                    next();
                }
            };
            processNext();
        }

    });

    return MainView;

});
